<div class="chat-list">
  <div *ngIf="msg.type === 'CHAT' || msg.type === 'CHAT_AUTOMATIC_MESSAGE' || msg.type === 'FILE' || msg.type === 'AUTOMATIC'">
    <div
      class="left"
      *ngIf="msg.type !== 'AUTOMATIC'"
      [ngClass]="msg.isFromCustomer() ? 'cng-ico_client_div' : 'cng-ico_agent_div'"
      aria-hidden="true"
    >
      <div class="rounded" *ngIf="msg.isFromCustomer() || (msg.isFromRealAgent() && !agentHaveProfilePicture())">
        <span *ngIf="msg.isFromCustomer()" class="cng-ico_user"></span>
        <span *ngIf="msg.isFromRealAgent() && !agentHaveProfilePicture()" class="cng-ico_agent"></span>
      </div>
      <img
        loading="lazy"
        *ngIf="msg.isFromRealAgent() && agentHaveProfilePicture()"
        class="cng-ico_agent_uploaded"
        [src]="getAgentPicture()"
      />
      <div *ngIf="msg.isFromBot()" class="cng-ico_chatbot"></div>
    </div>
    <div *ngIf="msg.type === 'AUTOMATIC'" class="left cng-ico_agent_div">
      <div class="cng-ico_chatbot"></div>
    </div>

    <div class="chat-message-content clearfix">
      <div class="interlocutor-fullName" *ngIf="msg.type !== 'AUTOMATIC'">
        <span *ngIf="msg.isFromCustomer()">
          <span *ngIf="chat.tab.chatName">{{ chat.tab.chatName | translate | uppercase }}</span>
        </span>
        <span *ngIf="msg.isFromRealAgent() && msg.csrId === csrId">
          {{ 'agent:contact.info.me' | translate }}
        </span>
        <span *ngIf="msg.isFromRealAgent() && msg.csrId !== csrId"> {{ msg.firstName }} {{ msg.lastName }} </span>
        <span *ngIf="msg.isFromBot()">
          {{ msg.firstName }}
        </span>
      </div>
      <div class="interlocutor-fullName" *ngIf="msg.type === 'AUTOMATIC'">
        <span>
          {{ 'agent:contact.info.engagement' | translate | uppercase }}
        </span>
      </div>
      <time class="chat-time">{{ msg.date | localizedDate: 'HH:mm' }}</time>

      <div *ngIf="msg.type !== 'FILE' && hasChatAssistancePermission" [ngClass]="displayCopyLayer ? 'copy-layer' : 'copy-layer-close'">
        <mat-menu #copyLayerMenu="matMenu" xPosition="before">
          <chat-copy-layer (copyToRoom)="onCopyToRoom($event)"></chat-copy-layer>
        </mat-menu>

        <button mat-icon-button [matMenuTriggerFor]="copyLayerMenu" class="cng-ico_menu_bullets"></button>
      </div>
      <div *ngIf="msg.type !== 'FILE'">
        <p [innerHTML]="getMessageContent()"></p>
      </div>

      <div *ngIf="msg.chatbotExchangeMessage && msg.chatbotExchangeMessage.imageUrl">
        <img loading="lazy" class="bot-message-picture" [src]="msg.chatbotExchangeMessage.imageUrl" />
      </div>

      <div *ngIf="msg.chatbotExchangeMessage && !msg.chatbotExchangeMessage.imageUrl && msg.chatbotExchangeMessage.attachment">
        <div class="attachment">
          <chat-attachment
            [filename]="msg.chatbotExchangeMessage.attachment.name"
            [size]="msg.chatbotExchangeMessage.attachment.size"
          ></chat-attachment>
          <div class="error-message" *ngIf="errorMessage">{{ 'agent:panel.chat.attachment.' + errorMessage | translate }}</div>
        </div>
      </div>

      <div *ngIf="msg.type === 'FILE'">
        <div class="attachment">
          <a (click)="downloadFile()">
            <chat-attachment [filename]="msg.attachment.fileName" [size]="msg.attachment.fileSize"></chat-attachment>
          </a>
          <div class="error-message" *ngIf="errorMessage">{{ 'agent:panel.chat.attachment.' + errorMessage | translate }}</div>
        </div>
      </div>
    </div>
  </div>
  <div *ngIf="msg.type === 'DISCONNECT'" class="chat-disconnect-message">
    {{ msg.firstName }} {{ msg.lastName }} {{ 'agent:panel.chat.message_box.disconnect_message' | translate }}
  </div>
</div>
